<template src="./index.html"></template>

<script>
import minhead from '../../../../common/minHead/index.vue';
import { getdata } from './data.js';
export default {
	components: {
		minhead
	},
	props: {
		mxparams:{
			type:Object,
			default:{}
		},
		tableData: {
			type: Array,
			default:[],
		}
	},
	data() {
		return {
			headData: getdata().headData,
			// tableData:getdata().tableData,
			isbianj: false,
			updataItem:[],
			tablekey:0,
		};
	},
	created() {
	},
	mounted() {},
	methods: {
		inputblur(e,code){
			this.$emit('inputblur',e,code)
		},
		isbjbcdj() {
			if(this.isbianj){
				this.$emit('preservation',this.tableData)
			}
			this.isbianj = !this.isbianj;
		
		},
		forback() {
			this.$emit('forback', '');
		}
	}
};
</script>

<style scoped lang="less">
@import url('index.less');
</style>
